/* global axios */
import ApiClient from './ApiClient';

// Alta embebida de WhatsApp (Embedded Signup): intercambia las credenciales del popup de Meta
// (code + waba_id + phone_number_id) por un inbox WhatsApp Cloud; con inbox_id reconecta uno existente.
// El recurso es singular (POST /api/v1/accounts/:id/whatsapp/authorization) como microsoft/authorization:
// no hay colección ni ids, solo la acción create. Al depurar, buscar la ruta por ese nombre.
class WhatsappAuthorization extends ApiClient {
  constructor() {
    super('whatsapp/authorization', { accountScoped: true });
  }

  // Si el número de la bandeja vive también en la app de WhatsApp Business ({ on_biz_app }); el
  // backend lo consulta a Meta y lo guarda si la bandeja aún no lo tenía.
  getBizAppStatus(inboxId) {
    return axios.get(this.url, { params: { inbox_id: inboxId } });
  }
}

export default new WhatsappAuthorization();
